import styled from 'styled-components';
import themeData from 'utils/theme/themeData';

const { typography } = themeData;

// ###############################################################
// <------------------- Order Details Header -------------------->
// ###############################################################
export const OrderDetailsHeaderWrapper = styled.div`
  display: flex;
  padding: 16px 0;
`;

export const OrderDetailsHeaderOrderInfoWrapper = styled.div`
  display: flex;
  align-items: center;

  & > * + * {
    margin-inline-start: 16px !important;
  }
`;

export const OrderDetailsHeaderOrderBtnWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-inline-start: auto;

  & > * + * {
    margin-inline-start: 4px !important;
  }
`;

export const OrderDetailsHeaderIconBtnWrapper = styled.div`
  position: relative;
`;

export const OrderDetailsHeaderIconBtn = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border: 1px solid ${({ theme }) => theme.colors.grey000};
  border-radius: 4px;
  box-sizing: border-box;
  cursor: pointer;

  &:before {
    content: ${({ icon }) => icon};
    font-family: 'Icomoon';
    color: ${({ theme }) => theme.colors.black};
  }
`;

export const OrderDetailsHeaderIconBtnMenu = styled.div`
  position: absolute;
  right: 0;
  padding: 4px 0;
  width: 160px;
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: 4px;
  box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.16);
  box-sizing: border-box;
`;

export const OrderDetailsHeaderIconBtnMenuItem = styled(typography.BodyTextOneRegularTypography)`
  margin: 0;
  padding: 6px 16px;
  color: ${({ theme }) => theme.colors.redMain};
  cursor: pointer;

  &: hover {
    background-color: ${({ theme }) => theme.colors.grey100};
  }
`;

export const OrderDetailsHeaderOrderId = styled(typography.LargeTitleTypography)`
  margin: 0;
  color: ${({ theme }) => theme.colors.black};
  cursor: pointer;
`;

export const OrderDetailsHeaderViewedBtn = styled(typography.BodyTextOneRegularTypography)`
  padding: 8px 16px;
  color: ${({ theme }) => theme.colors.white};
  background-color: ${({ theme, disabled }) =>
    disabled ? theme.colors.grey005 : theme.colors.greenMain};
  border: 0;
  border-radius: 4px;
  cursor: ${({ disabled }) => !disabled && 'pointer'};

  &:before {
    content: '\\e908';
    font-family: 'Icomoon';
    font-size: 12px;
    margin-inline-end: 8px;
  }
`;

export const OrderDetailsHeaderProcessedBtn = styled(OrderDetailsHeaderViewedBtn)``;

export const OrderDetailsHeaderResultsDoneBtn = styled(OrderDetailsHeaderViewedBtn)``;

export const OrderDetailsHeaderScheduleBtn = styled(OrderDetailsHeaderViewedBtn)`
  background-color: ${({ theme }) => theme.colors.blueMain};

  &:before {
    content: '\\e90c';
  }
`;
// ###############################################################
// <----------------- End Order Details Header ------------------>
// ###############################################################

// ###############################################################
// <-------------------- Order Action Popup --------------------->
// ###############################################################
export const OrderDetailsHeaderActionsPopupWrapper = styled.div`
  padding: 30px 0;
  min-width: 550px;
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: 8px;
`;

export const OrderDetailsHeaderActionsPopupTitleWrapper = styled.div`
  text-align: center;
`;

export const OrderDetailsHeaderActionsPopupTitle = styled(typography.TitleTwoTypography)`
  margin: 0;
`;

export const OrderDetailsHeaderActionsPopupBtnWrapper = styled.div`
  display: flex;
  padding: 0 20px;

  & * + * {
    margin-inline-start: 15px !important;
  }
`;

export const OrderDetailsHeaderActionsPopupYesBtn = styled(typography.BodyTextOneRegularTypography)`
  margin: 0;
  padding: 8px 0;
  width: 60px;
  color: ${({ theme }) => theme.colors.white};
  background-color: ${({ theme }) => theme.colors.greenMain};
  border: 0;
  border-radius: 4px;
  cursor: pointer;
`;

export const OrderDetailsHeaderActionsPopupNoBtn = styled(OrderDetailsHeaderActionsPopupYesBtn)`
  margin: 0;
  color: ${({ theme }) => theme.colors.redMain};
  background-color: ${({ theme }) => theme.colors.redLight};
`;
// ###############################################################
// <------------------ End Order Action Popup ------------------->
// ###############################################################

// ###############################################################
// <------------------- Schedule Order Popup -------------------->
// ###############################################################
export const OrderDetailsScheduleOrderPopupWrapper = styled.div`
  width: 680px;
  padding: 16px 0;
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: 8px;
  box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.16);
`;

export const OrderDetailsScheduleOrderPopupTitleWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 0 24px;
`;

export const OrderDetailsScheduleOrderPopupTitle = styled(typography.TitleOneRegularTypography)`
  margin: 0;
  color: ${({ theme }) => theme.colors.black};
`;

export const OrderDetailsScheduleOrderPopupTitleSpan = styled(typography.TitleOneRegularTypography)`
  margin: 0;

  &:before {
    content: '\\e91f';
    font-family: 'Icomoon';
    cursor: pointer;
  }
`;

export const OrderDetailsScheduleOrderSectionTitle = styled(typography.TitleTwoTypography)`
  margin: 0;
  color: ${({ theme }) => theme.colors.black};
`;

export const OrderDetailsCancelSectionSubTitle = styled(typography.TitleTwoTypography)`
  margin: 0;
  color: ${({ theme }) => theme.colors.black};
  padding-bottom: 8px;
`;

export const OrderDetailsScheduleOrderDateTimeSectionWrapper = styled.div`
  display: flex;
  padding: 0 24px;

  & > * + * {
    margin-inline-start: 16px !important;
  }
`;

export const OrderDetailsScheduleOrderDateTimeWrapper = styled.div`
  flex: 1;
`;

export const OrderDetailsScheduleOrderReasonsWrapper = styled.div`
  padding: 0 24px;
  overflow-y: auto;
  max-height: 60vh;
`;

export const OrderDetailsScheduleOrderInsuranceWrapper = styled.div`
  padding: 0 24px;
`;

export const OrderDetailsScheduleOrderNoteWrapper = styled.div`
  padding: 0 24px;
`;

export const OrderDetailsScheduleOrderNoteTextArea = styled.textarea`
  width: 100%;
  height: 56px;
  padding: 8px 12px;
  border: 1px solid ${({ theme }) => theme.colors.grey000};
  border-radius: 4px;
  box-sizing: border-box;
  outline: none;
  vertical-align: top;
  resize: none;

  &::-webkit-input-placeholder {
    font-family: 'Lato';
    font-weight: 400;
    color: ${({ theme }) => theme.colors.grey005};
  }
  &:-moz-placeholder {
    font-family: 'Lato';
    font-weight: 400;
    color: ${({ theme }) => theme.colors.grey005};  
  }
  &::-moz-placeholder {
    font-family: 'Lato';
    font-weight: 400;
    color: ${({ theme }) => theme.colors.grey005};  
  }
  &:-ms-input-placeholder {
    font-family: 'Lato';
    font-weight: 400;
    color: ${({ theme }) => theme.colors.grey005};  
  }
  &::placeholder {
    font-family: 'Lato';
    font-weight: 400;
    color: ${({ theme }) => theme.colors.grey005};  
  }
}
`;

export const OrderDetailsScheduleOrderBtnWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: 0 24px;

  & > * + * {
    margin-inline-start: 8px !important;
  }
`;

export const OrderDetailsScheduleOrderSaveBtn = styled(typography.BodyTextOneRegularTypography)`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 96px;
  height: 36px;
  margin: 0;
  margin-inline-start: auto;
  color: ${({ theme }) => theme.colors.white};
  background-color: ${({ theme, disabled }) =>
    disabled ? theme.colors.grey000 : theme.colors.blueMain};
  border: 1px solid ${({ theme, disabled }) => !disabled && theme.colors.blueMain};
  border-radius: 4px;
  box-sizing: border-box;
  cursor: pointer;
`;

export const OrderDetailsScheduleOrderCancelBtn = styled(OrderDetailsScheduleOrderSaveBtn)`
  ${({ theme }) => `
    color: ${theme.colors.black};
    background-color: ${theme.colors.grey100};
    border: 1px solid ${theme.colors.grey000};
  `}
`;

export const OrderDetailsScheduleOrderError = styled.div`
  display: block;
  padding-top: 5px;
  padding-bottom: 12px;
  font-size: 14px;
  color: ${({ theme }) => theme.colors.redMain};
`;

// ###############################################################
// <----------------- End Schedule Order Popup ------------------>
// ###############################################################

// ###############################################################
// <------------------- Select Items Section -------------------->
// ###############################################################

export const OrderState = styled.div`
  display: block;
  font-weight: 700;
  ${({ first }) => (first ? 'border-radius: 5px 5px 0px 0px;' : 'border-radius: 0px')}
  color: #646464;
  font-size: 15px;
  font-weight: 700;
  padding-bottom: 5px;
  position: relative;
`;

export const Label = styled.label`
  color: #646464;
  font-size: 14px;
  font-weight: 400;
  ${({ clickable }) => clickable && 'cursor: pointer;'}
`;

export const CheckboxGroupWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
`;

export const SelectedItem = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 6px 16px;
  font-size: 13px;
  line-height: 20px;
  margin-top: 5px;
  border-radius: 4px;
  border: 3px solid #f1f4f6;
  color: #646464;

  &:hover {
    background-color: ${({ disableHoverEffect }) => !disableHoverEffect && '#F1F4F6'};
  }
`;

export const DeleteIcon = styled.div`
  margin-left: auto;

  &:before {
    content: '\\e918';
    font-family: 'Icomoon';
    color: ${({ theme }) => theme.colors.redMain};
  }
`;

// ###############################################################
// <----------------- End Select Items Section ------------------>
// ###############################################################
